import { useEffect, useMemo, useRef } from 'react';
import { useMatch } from 'react-router-dom';

export interface UseTitleOptions {
  restoreOnUnmount?: boolean;
}

export const DEFAULT_USE_TITLE_OPTIONS: UseTitleOptions = {
  restoreOnUnmount: false,
};

let useRouteDocumentTitle = function useRouteDocumentTitle(
  title: string,
  routePath: string,
  options: UseTitleOptions = DEFAULT_USE_TITLE_OPTIONS,
) {
  const prevTitleRef = useRef(document.title);
  const matchPath = useMatch(routePath);

  const isMatching = useMemo(() => !!matchPath, [matchPath]);

  useEffect(() => {
    if (!isMatching) return;
    if (document.title !== title) document.title = `${title} - EXIO Næring`;
  }, [title, isMatching]);

  useEffect(() => {
    if (options && options.restoreOnUnmount) {
      return () => {
        // useRef is used to set title back to previous title when unmounting component
        document.title = prevTitleRef.current; // eslint-disable-line react-hooks/exhaustive-deps
      };
    } else {
      return;
    }
    // the dependency array is empty on purpose so we reset page title to default
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

if (typeof document === 'undefined') useRouteDocumentTitle = (_title: string) => {}; // eslint-disable-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function

export { useRouteDocumentTitle };

export default useRouteDocumentTitle;
